import { PUZZLE_STATUSES } from 'app-constants';
import { deleteDoc, doc, getDoc, updateDoc } from 'firebase/firestore';
import { firestore } from 'services/Firebase';

export declare interface DeletionResult {
  readonly errors: string[];
}

/**
 * Deletes puzzle document in "puzzles" collection
 */
export const deletePuzzleAndAssets = async (id: string): Promise<void> => {
  const puzzleRef = doc(firestore, 'puzzles', id);
  const data = await getDoc(puzzleRef);

  if (!data.exists()) {
    throw 'Puzzle does not exist';
  }

  const puzzleData = data.data();
  if (!puzzleData) {
    throw 'Failed to fetch puzzle data';
  }

  await deleteDoc(puzzleRef);
};

/**
 * Soft Delete Puzzle.
 */
export const softDeletePuzzle = async (id: string): Promise<void> => {
  //Required doc references
  const puzzleDocRef = doc(firestore, 'puzzles', id);

  //Puzzle doc
  const puzzle = await getDoc(puzzleDocRef);

  //Check if exist
  if (!puzzle.exists()) {
    throw 'Puzzle does not exist';
  }

  //Set status of "deleted" on "puzzles" collection
  await updateDoc(puzzleDocRef, { status: PUZZLE_STATUSES.deleted });
};
